import { ComponentProps, JSXElementConstructor } from 'react';
import { registerModals } from '../utils/registry';
import Info from '../bottomSheets/Info/Info';

const modals = {
  Info,
};

registerModals('common', modals);

declare global {
  interface RegisteredModals {
    common: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
